import React, {RefObject} from 'react';

import {useGooglePlacesWidget} from 'hooks/useGooglePlacesWidget';

import {Input} from '../input/input';

import {GooglePlacesType} from './addressField.types';

export type PropsType = {
    label: string;
    onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange: (value: string) => void;
    onAutocomplete: (places: GooglePlacesType) => void;
    errorMessage: string | boolean;
    success?: boolean;
    value: string;
    attributes: {
        [key: string]: string | number;
    };
    country: string;
};

const keyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>) =>
    e.key === 'Enter' && e.preventDefault();

/**
 * Component input with integrated Google Places API
 * @param {PropsType} props type
 * @returns {React.ReactNode} react node
 */
export function AddressField(props: PropsType) {
    const {attributes, country, errorMessage, label, onAutocomplete, onBlur, success, value} =
        props;

    const {ref} = useGooglePlacesWidget({country, inputAutocompleteValue: 'off', onAutocomplete});

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e.target.value);
    };

    return (
        <Input
            ref={
                process.env.GOOGLE_API_KEY ? (ref as unknown as RefObject<HTMLInputElement>) : null
            }
            errorMessage={errorMessage}
            label={label}
            onBlur={onBlur}
            onChange={changeHandler}
            onKeyDown={keyDownHandler}
            success={success}
            value={value}
            {...attributes}
        />
    );
}
